import React, {useState} from 'react';
import FormInput from "../../../Components/Forms/FormInput";
import {COUNTRY_OPTIONS, MONTH_OPTIONS, YEAR_OPTIONS} from "../../../constants";
import SecondaryTitle from "../../../Components/SecondaryTitle";
import Text from "../../../Components/Text";
import DetaileddetailedLabel from "../../../Components/Forms/DetailedLabel";

const CorrespondenceAddressDetails = (props) => {
    const {
        data = {
            'correspondence_address_line_1':                 '',
            'correspondence_address_line_2':                 '',
            'correspondence_town_city':                      '',
            'correspondence_state_county':                   '',
            'correspondence_postcode':                       '',
            'correspondence_country':                        '',
            'correspondence_occupied_since_year':            '',
            'correspondence_occupied_since_month':           '',
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <SecondaryTitle>Correspondence Address</SecondaryTitle>
            <div className={'row m-0 p-0'}>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_address_line_1'}
                        detailedLabel={'Address line 1'}
                        value={data.correspondence_address_line_1}
                        type={'text'}
                        onChange={(value) => onChange('correspondence_address_line_1', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        name={'correspondence_address_line_2'}
                        detailedLabel={'Address line 2'}
                        value={data.correspondence_address_line_2}
                        type={'text'}
                        onChange={(value) => onChange('correspondence_address_line_2', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_town_city'}
                        detailedLabel={'Town / City'}
                        value={data.correspondence_town_city}
                        type={'text'}
                        onChange={(value) => onChange('correspondence_town_city', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        name={'correspondence_state_county'}
                        detailedLabel={'County / State'}
                        value={data.correspondence_state_county}
                        type={'text'}
                        onChange={(value) => onChange('correspondence_state_county', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_postcode'}
                        detailedLabel={'Postcode'}
                        value={data.correspondence_postcode}
                        type={'text'}
                        onChange={(value) => onChange('correspondence_postcode', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_country'}
                        detailedLabel={'Country'}
                        value={data.correspondence_country}
                        type={'select'}
                        options={COUNTRY_OPTIONS}
                        onChange={(value) => onChange('correspondence_country', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <DetaileddetailedLabel detaileddetailedLabel={'Occupied this Address Since'} style={{paddingLeft: 0}}/>
                <div className={'col-12 col-md-6 m-0 p-0 pe-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_occupied_since_year'}
                        detailedLabel={'Year'}
                        value={data.correspondence_occupied_since_year}
                        type={'select'}
                        options={YEAR_OPTIONS}
                        onChange={(value) => onChange('correspondence_occupied_since_year', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
                <div className={'col-12 col-md-6 m-0 p-0 ps-md-2'}>
                    <FormInput
                        required={true}
                        name={'correspondence_occupied_since_month'}
                        detailedLabel={'Month'}
                        value={data.correspondence_occupied_since_month}
                        type={'select'}
                        options={MONTH_OPTIONS}
                        onChange={(value) => onChange('correspondence_occupied_since_month', value)}
                        disabled={disabled}
                        error={errors}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default CorrespondenceAddressDetails;
